import { createContext } from "react";
const LoginQuestionContext = createContext();

export default LoginQuestionContext;